module.exports = __webpack_public_path__ + "static/media/church-icon.fb91dafc.png";